import React, { useState, useEffect } from 'react';
import styles from './InputPage.module.css';
import RenderComponente from './RenderComponente';
import logo from '../assets/logo.png';

// Exemplos para o slider
const exemplosConsulta = [
  'CPF: 062.XXX.XXX-XX',
  'Comprovante Pix: Joao,<MEIO_DO_CPF>',
  'Nome: João da Silva',
  'Telefone: 31 99888-9999',
  'CPF : 123.456.789-09',
  'CNPJ: 12.345.678/000X-XX',
  'Email: joao@email.com',
];

export default function InputPage({ onAnalisar, onDemo, loading, erro, resultado, parametro, tipo, user, onLogout }) {
  const [input, setInput] = useState('');
  const [parseErro, setParseErro] = useState(null);
  const [objetivo, setObjetivo] = useState('legitimo');


  // Slider de exemplo de consulta:
  const [exemploIdx, setExemploIdx] = useState(0);

  function proxExemplo() {
    setExemploIdx(i => (i + 1) % exemplosConsulta.length);
  }
  function antExemplo() {
    setExemploIdx(i => (i - 1 + exemplosConsulta.length) % exemplosConsulta.length);
  }

  // Avanço automático do slider
  useEffect(() => {
    const interval = setInterval(() => {
      setExemploIdx(i => (i + 1) % exemplosConsulta.length);
    }, 5000); // Troca a cada 5 segundos
    return () => clearInterval(interval);
  }, []);

  const objetivos = [
    { value: 'legitimo', label: 'Legítimo Interesse', desc: 'Atender interesses legítimos respeitando direitos fundamentais' },
    { value: 'identidade', label: 'Confirmação de Identidade', desc: 'Prevenção de Fraudes e autenticidade de identidade' },
    { value: 'credito', label: 'Ciclo de Crédito', desc: 'Análise Financeira, cobrança e concessão de crédito' },
    { value: 'contrato', label: 'Execução de Contrato', desc: 'Procedimentos preliminares relacionados a contratos' },
  ];
  function handleSubmit() {
    setParseErro(null);
    if (!objetivo) {
      setParseErro('Selecione o objetivo da consulta.');
      return;
    }
    if (!input.trim()) {
      setParseErro('Informe um dado para análise.');
      return;
    }

    onAnalisar(input.trim());
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' && !loading) {
      handleSubmit();
    }
  }

  function fillExample(text) {
    const clean = text.split(': ')[1] || text;
    setInput(clean);
    setParseErro(null);
  }

  return (
    <div className="history-root">
      {/* Header */}
      {/* <header className={styles.header}>
        <div className={styles.logo}>
          <img
            src={logo}
            alt="Analise Central"
            className={styles.logoImage}
          />
        </div>
        <div className={styles.accountBox}>
          <div className={styles.accountMeta}>
            <strong>{user?.empresa || 'Conta autenticada'}</strong>

            <span
              className={`${styles.creditInfo} ${
                user?.creditsExpired ? styles.creditExpired : ''
              }`}
            >
              {user?.credits ?? 0} {
                user?.creditsExpired ? 'expirados' : ' créditos'
              }
            </span>
          </div>
          <a href="/recargas" className={styles.btnRecargas}>
            Recargas
          </a>
          <a href="/historico" className={styles.btnRecargas}>
            Historico
          </a>
          <button className={styles.btnLogout} onClick={onLogout} type="button">
            Sair
          </button>
        </div>
      </header> */}

      <header className="history-header">
        <div className="container">
          <div className="history-header-inner">
            <a href="/" className="history-logo"><img src={logo} alt="AnaliseCentral" style={{height: '100px'}} /></a>
            <nav className="history-header-nav">
              <a href="#" className="active">Inicio</a>
              <a href="/historico" >Histórico</a>
              <a href="/recargas" >Recargas</a>
            </nav>
            <div className="history-user">
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span className="user-name">{user?.empresa || 'Conta autenticada'}</span>
                <span
                  className={`${styles.creditInfo} ${user?.creditsExpired ? styles.creditExpired : ''
                    }`}
                >
                  {user?.credits ?? 0} {
                    user?.creditsExpired ? 'expirados' : ' créditos'
                  }
                </span>
              </div>
              <button className="btn-sair" onClick={onLogout}>Sair</button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero */}
      <div className="history-hero">
        <div className="container">
          <h1>Antifraude para <span className={styles.heroAccent}>revendas</span></h1>
          <p className="history-hero-desc">
            Consulte e valide dados em segundos.
          </p>
        </div>
      </div>


      <main className={styles.main}>
        {/* Hero */}
        {/* <div className={styles.hero}>
          <h1 className={styles.heroTitle}>
            Valide seu <span className={styles.heroAccent}>cliente</span>
          </h1> 
          <p className={styles.heroSub}>
            Consulte e valide dados em segundos.
          </p>
        </div>*/}


        {/* Card */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <span className={styles.cardLabel}>Dados do cliente</span>
            <span className={styles.cardHint}>
              CPF, CNPJ, telefone, nome, e-mail ou pelo comprovante pix
            </span>
          </div>

          {/* Slider de exemplos */}
          <span style={{ fontSize: '1.2rem', color: '#555', textAlign: 'center', display: 'block' }}>
              Exemplos de consulta: 
            </span>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '12px 0' }}>
            <button
              style={{
                background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', padding: '0 8px', color: '#888'
              }}
              aria-label='Exemplo anterior'
              onClick={antExemplo}
              type='button'
            >&lt;</button>
            <div style={ {
                fontSize: '1.08rem',
                padding: '8px 18px',
                background: '#f7f7f9',
                borderRadius: '14px',
                minWidth: '180px',
                textAlign: 'center',
                margin: '0 10px',
                boxShadow: '0 1px 4px #0001',
              }}>
                <span style={{userSelect: 'text'}}>{exemplosConsulta[exemploIdx]}</span>
                
            </div>
            <button
              style={{
                background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', padding: '0 8px', color: '#888'
              }}
              aria-label='Próximo exemplo'
              onClick={proxExemplo}
              type='button'
            >&gt;</button>
          </div>

          <div className={styles.inputWrapper}>
            <label htmlFor="objetivo">
              Objetivo da consulta <span className="required">*</span>
            </label>
            {objetivo && (
              <p className="objetivo-desc" style={{marginBottom: '6px'}}>
                {objetivos.find(o => o.value === objetivo)?.desc}
              </p>
            )}
              <select
                id="objetivo"
                className={styles.input}
                style={{marginBottom: '12px'}}
                value={objetivo}
                onChange={(e) => { setObjetivo(e.target.value); if (erro) setParseErro(null); }}
              >
                {objetivos.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            <input
              className={styles.input}
              type="text"
              value={input}
              onChange={e => {
                setInput(e.target.value);
                setParseErro(null);
              }}
              onKeyDown={handleKeyDown}
              placeholder="Ex: 062.XXX.XXX-XX ou João da Silva"
              autoComplete="off"
              spellCheck="false"
            />
          </div>

          {(parseErro || erro) && (
            <div className={styles.erroBox}>
              <span>⚠️</span>
              {parseErro || erro}
            </div>
          )}

          <div className={styles.actions}>
            <button
              className={styles.btnAnalisar}
              onClick={handleSubmit}
              disabled={loading}
              type="button"
            >
              {loading ? (
                <span className={styles.spinner}>Analisando</span>
              ) : (
                <>
                  Analisar cliente
                  <span>→</span>
                </>
              )}
            </button>
          </div>
        </div>

        {/* Result */}
        {resultado && (
          <div className={styles.resultSection}>
            <RenderComponente
              resultado={resultado}
              parametro={parametro}
              tipo={tipo}
              setInput={setInput}
              onConsultar={onAnalisar}
            />
          </div>
        )}
      </main>
    </div>
  );
}